"use strict";

exports.__esModule = true;
exports.TabsElement = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _common = require("../common");
var _SelectionContext = require("../../Core/SelectionContext");
var _styles = require("./styles");
var _helpers = require("./helpers");
var _Env = require("../../Env");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Displays a list of tabs.
 */
var TabsElement = exports.TabsElement = function TabsElement(props) {
  var id = props.id,
    orientation = props.orientation,
    children = props.children;
  var selection = (0, _react.useContext)(_SelectionContext.SelectionContext);
  var tabsListRef = (0, _react.useRef)();
  // The ref is still empty while the first render runs, so measure after every
  // commit instead: the tab list's size is subtracted from the panel size, and
  // TabsWrapper clips whatever the panel overshoots by.
  var _useState = (0, _react.useState)(_helpers.defaultTabsListDimensions),
    tabsListDimensions = _useState[0],
    setTabsListDimensions = _useState[1];
  (0, _react.useLayoutEffect)(function () {
    var measured = (0, _helpers.getTabsListDimensions)(tabsListRef.current);
    if (measured.height !== tabsListDimensions.height || measured.width !== tabsListDimensions.width) {
      setTabsListDimensions(measured);
    }
  });
  var _useContext = (0, _react.useContext)(_Env.EnvContext),
    featureFlags = _useContext.featureFlags;
  var onTabChange = selection ? selection.resetSelection : function () {};
  return /*#__PURE__*/_react["default"].createElement(_styles.TabsWrapper, _extends({}, (0, _common.getWidgetCSSProps)(props), {
    "data-testid": "TabsElement"
  }), /*#__PURE__*/_react["default"].createElement(_core.Tabs, {
    ref: tabsListRef,
    id: id,
    vertical: orientation === "vertical",
    onChange: onTabChange,
    large: true,
    renderActiveTabPanelOnly: true
  }, children.map(function (child, index) {
    var _child$props, _child$props2;
    if ((_child$props = child.props) != null && _child$props.featureFlag && !featureFlags.includes((_child$props2 = child.props) == null ? void 0 : _child$props2.featureFlag)) {
      return null;
    }
    return (0, _helpers.RenderTabContent)({
      child: child,
      index: index,
      props: props,
      tabsListDimensions: tabsListDimensions
    });
  })));
};